export default function cacncref(){
    return(
        <div>
            Cancellation & Refund Policy
JobSniper provides digital services delivered instantly after purchase.
Once analysis or flow creation begins, no refunds are issued.
If a user is charged but does not receive access due to a technical issue, they may request support within 24 hours at jobsniperteam@gmail.com
 and we will resolve or refund the issue.
We do not offer refunds for incorrect uploads, dissatisfaction with results, or change of mind.
        </div>
    )
}